function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedLoftBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2c.55 0 1 .45 1 1v3.17A3 3 0 015 6c0-1.66 1.34-3 3-3h2c1.66 0 3 1.34 3 3h14a3 3 0 011 .17V3c0-.55.45-1 1-1s1 .45 1 1v27h-2V13h-2v17h-2v-2h-5v2h-2V13H4v6h8.8c.66 0 1.2.54 1.2 1.2V30h-2v-4H4v4H2V3c0-.55.45-1 1-1zm9 19v3H4v-3h8zm12 2v3h-5v-3h5zm-5-2h5v-3h-5v3zm5-8v3h-5v-3h5zm4-2V9c0-.55-.45-1-1-1h-1v3h2zm-4-3v3h-5V8h5zM4 9c0-.55.45-1 1-1h12v3H4V9zm3-3h4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1z",
    fill: props.color
  }));
}

export default SvgIconBedLoftBedFilled;